import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import profile from "../../assets/image/profile.png";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";
import { CiSearch } from "react-icons/ci";

export default function ContactCustomer() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [error, setError] = useState("");
  const [active, setActive] = useState("All");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchQuery(search);
    }, 400);
    return () => clearTimeout(timer);
  }, [search]);

  const fetchMessages = async () => {
    try {
      setTableLoading(true);
      setError("");

      const response = await apiRequests.get(
        "/tickets/v1/get-my-ticket-list-seller-user",
        {
          params: {
            page,
            limit,
            search: searchQuery,
          },
        },
      );

      const result = response.data;

      if (!result.data?.docs) {
        setMessages([]);
        return;
      }

      setMessages(result.data.docs);
    } catch (err) {
      console.error(err);
      setMessages([]);
      setError("Failed to load chats.");
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [page, searchQuery]);

  const buttons = [
    { label: "All", value: "All" },
    { label: "messages", value: "messages" },
    { label: "order reports", value: "order reports" },
  ];

  if (loading) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-gray-500 font-medium">
        Loading messages...
      </div>
    );
  }

  if (error) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-red-500 font-medium">
        {error}
      </div>
    );
  }

  return (
    <div className="w-full px-10 flex gap-6 flex-col">
      <div className="flex flex-row justify-between items-center sm:flex-col sm:items-start sm:gap-3">
        <h1 className="text-2xl font-semibold text-[#1f1b18]">
          Contact customers
        </h1>

        <div className="flex items-center gap-4">
          <div className="relative w-75">
            <CiSearch className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />

            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name..."
              className="w-full h-11 pl-11 pr-4 rounded-xl border border-gray-200
                   bg-white text-sm text-gray-700 outline-none
                   focus:border-[#024E88]"
            />
          </div>
          {/* Buttons */}
          <div className="flex flex-wrap gap-2 text-lg font-medium">
            {buttons.map((btn) => (
              <button
                key={btn.value}
                onClick={() => {
                  setActive(btn.value);
                  setPage(1);
                }}
                className={`border rounded-xl px-4 py-1 font-medium transition-colors ${
                  active === btn.value
                    ? "bg-[#BCB6B3] text-black border-[#BCB6B3]"
                    : "border-[#5C5957] text-[#5C5957] hover:bg-[#BCB6B3]"
                }`}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full overflow-x-auto rounded-t-2xl">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-[#051F33] to-[#024E88] text-white">
              <th className="p-4 font-medium capitalize pl-8">customer</th>
              <th className="p-4 font-medium capitalize text-center">
                ticket title
              </th>
              <th className="p-4 font-medium capitalize text-center">
                order id
              </th>
              <th className="p-4 font-medium capitalize text-center">action</th>
            </tr>
          </thead>
          <tbody>
            {messages.length > 0 ? (
              messages.map((e) => (
                <tr
                  key={e._id}
                  className="border-b border-[#AE9C91] hover:bg-gray-50 h-16 transition-colors"
                >
                  <td className="p-4 pl-8">
                    <div className="flex items-center gap-4">
                      <img
                        src={profile}
                        alt={e.creator.user_id.userName}
                        className="w-10 h-10 rounded-full object-cover shadow-sm border border-gray-100"
                      />
                      <span className="text-gray-600 font-medium">
                        {e.creator.user_id.userName}
                      </span>
                    </div>
                  </td>

                  <td className="p-4 text-center text-gray-600">{e.subject}</td>

                  <td className="p-4 text-center text-gray-600">{e.orderId}</td>

                  <td className="p-4 text-center">
                    <button
                      onClick={() =>
                        navigate(`/contactcustomer/CustomerChat/${e._id}`)
                      }
                      className="text-cyan-500 hover:text-cyan-700 font-medium text-sm"
                    >
                      see chat
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="p-10 text-center text-gray-500">
                  No messages found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
